<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id" :initialAttr="initialAttr">
        <div class="widget_menu">
            <wj-menu 
                :id="attr.html_id"
                :class="menuClass"
                v-uiHelp="uiHelpKey ? { key: uiHelpKey } : null"
                :displayMemberPath="'titleAction'" 
                :subItemsPath="'attrs'" 
                :showDropDownButton="false"
                v-if="attr.visible !== false && attr.hide !== true && store?.eval_value(WIDGET, attr['v-if'], {}, attr)"
                :openOnHover="true"
                :isAnimated="false" 
                :itemsSource="itemsSourceMenu" 
                :initialized="initMenu" 
                :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
            >
                <!-- <i class="pi pi-bars"></i> -->
            </wj-menu>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { langVersion } from '@/i18n'   // IE 2026 09 24 / ODOO-341407: пересборка itemsSource после смены языка без reload

export default {
    props: {
        attr_id: String,
        widget_id: [String, Number],
        initialAttr: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        attr: {},
        WIDGET: {},
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    beforeUnmount() {
        this.store.attr_deregister(this)
    },
    watch: {
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): меню с подписью (attr.headerHtml — кнопка «Plan approval» шапки Баланса: чипы видов плана + подпись) — заголовок wj-menu
        headerHtml(v) { this.menuHeader_apply(v) },
        initialAttr(attr) {
            // ремоунта нет, если :key совпал — подхватываем новый объект вручную
            if (attr) { this.content_Changed() }
        },
    },
    methods: {
        content_Changed() {
            if (this.initialAttr) {
                // attr передан объектом — id в поиске не участвует (опционален);
                // регистрацию в реестре по id сохраняем
                this.attr = this.initialAttr
                if (this.attr_id != null) {
                    this.WIDGET.attrs_vueObj[this.attr_id] = this
                }
            } else {
                this.store.widget_attr_set(this)
            }
        },
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): заголовок wj-menu (innerHTML; разметку и экранирование даёт владелец кнопки — utils/planApproval.planApproval_headerHtml)
        menuHeader_apply(v) {
            const menu = this[this.attr?.html_id]
            if (!menu || v === undefined) return
            try { if (menu.header !== v) menu.header = v } catch (e) { /* меню пересоздаётся */ }
        },
        initMenu(menu) {
            this[menu.hostElement.id] = menu
            if (this.headerHtml) this.menuHeader_apply(this.headerHtml)   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
            // IE 2026 08 21 (скрин Игоря 19:31): на телефоне тап по папке (subItems)
            // не доходит до itemClicked — перехватываем на дропдауне в capture-фазе
            // и раскрываем содержимое папки НА МЕСТЕ («‹ Back» — возврат)
            const drill = (e) => {
                if (!this.store.mobileUi?.on) return
                const el = e.target.closest?.('.wj-listbox-item')
                if (!el || !menu.dropDown?.contains(el)) return
                const items = [...menu.dropDown.querySelectorAll('.wj-listbox-item')]
                const item = menu.itemsSource?.[items.indexOf(el)]
                if (!item) return
                if (item.attrs?.length) {
                    e.stopPropagation(); e.preventDefault()
                    // IE 2026 08 22: INLINE — дети под пунктом, повторный тап сворачивает
                    const src = menu.itemsSource.slice()
                    const idx = src.indexOf(item)
                    if (idx < 0) return
                    const d0 = item._menuDepth || 0
                    if (item._menuOpen) {
                        let end = idx + 1
                        while (end < src.length && (src[end]._menuDepth || 0) > d0) end++
                        for (let j = idx + 1; j < end; j++) src[j]._menuOpen = false
                        src.splice(idx + 1, end - idx - 1)
                        item._menuOpen = false
                    } else {
                        const children = item.attrs.filter(a => a.use !== false && a.hidden !== true && this.store.checkAccess(a, this.WIDGET))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                        children.forEach(a => { a._menuDepth = d0 + 1 })
                        src.splice(idx + 1, 0, ...children)
                        item._menuOpen = true
                    }
                    menu.itemsSource = src
                    menu.selectedIndex = -1
                    setTimeout(() => { menu.isDroppedDown = true }, 50)
                    // IE 2026 08 23 (скрин Игоря 11:27): раскрытая папка у нижнего
                    // края — прокрутить панель: заголовок папки виден сверху, дети в кадре
                    if (item._menuOpen) setTimeout(() => {
                        const p = menu.dropDown
                        const el = p?.querySelectorAll?.('.wj-listbox-item')?.[idx]
                        if (el && p.scrollHeight > p.clientHeight + 4) {
                            const top = el.getBoundingClientRect().top - p.getBoundingClientRect().top + p.scrollTop
                            p.scrollTop = Math.max(0, Math.min(top - 8, p.scrollHeight - p.clientHeight))
                        }
                    }, 170)
                }
            }
            // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): меню внутри формы ячейки (панель ROW: «Approval») — список wijmo лежит в body с z-index 1500 (Control._POPUP_ZINDEX), а сама форма — z-index 9999:
            // список оказывался ПОД формой (виден лишь кусок, выступающий снизу; у высокой формы — не виден совсем: пункты «Reopen · Marketing director» не прочитать). Класс menu-over-form поднимает такой список над формой
            // (CSS ниже); меню таблицы и прочие меню — как были. Выключатель fe.ux.cellFormMenuOnTop (по умолчанию вкл.)
            menu.isDroppedDownChanged.addHandler(() => {
                const dd = menu.dropDown
                if (menu.isDroppedDown && dd && !dd._ovrForm) {
                    dd._ovrForm = true
                    try { if (this.store.setting('fe.ux.cellFormMenuOnTop', true) !== false && menu.hostElement.closest('.dropdown')) dd.classList.add('menu-over-form') } catch (e) { /* без подъёма: как было */ }
                }
            })
            menu.isDroppedDownChanged.addHandler(() => {
                if (this.store.mobileUi?.on) document.body.classList.toggle('wj-menu-open', menu.isDroppedDown)
                if (menu.isDroppedDown && menu.dropDown && !menu.dropDown._drillHooked) {
                    menu.dropDown._drillHooked = true
                    // click до панели не доходит (wijmo гасит/пересобирает) —
                    // ловим mousedown и touchstart
                    menu.dropDown.addEventListener('mousedown', drill, true)
                    menu.dropDown.addEventListener('touchstart', drill, true)
                }
            })
        },
        menuNodeClicked(menu) {
            let actionMenu = menu.itemsSource[menu.selectedIndex]
            // IE 2026 08 21 (скрин Игоря 19:31): на телефоне hover нет — тап по
            // папке (subItems, напр. «Command panel») раскрывает её содержимое
            // НА МЕСТЕ, первым пунктом «‹ Back» возврат к корню меню
            if (this.store.mobileUi?.on && actionMenu) {
                if (actionMenu._menuBack) {
                    menu.itemsSource = actionMenu._menuBack
                    setTimeout(() => { menu.isDroppedDown = true }, 0)
                    return
                }
                if (actionMenu.attrs?.length) {
                    const children = actionMenu.attrs.filter(a => a.use !== false && a.hidden !== true && this.store.checkAccess(a, this.WIDGET))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                    menu.itemsSource = [{ titleAction: '\u2039 ' + this.t('Back'), _menuBack: menu.itemsSource }, ...children]   // IE 2026 09 23 / ODOO-341407: i18n
                    setTimeout(() => { menu.isDroppedDown = true }, 0)
                    return
                }
            }
            let vueObj = this.WIDGET.vueObj
            // event с target=хост корневого меню — для методов, позиционирующихся
            // по кнопке (onFillColor/onRowStyleColor/onRowStyleCustom)
            const host = (this[this.attr.html_id] || menu).hostElement
            this.store.executeStoreMethod(vueObj, actionMenu, null, null, { target: host })
        },
    },
    computed: {
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: ключ по cssClass — только два известных меню шапки виджета (Compare / Approve plans);
        // прочие возможные использования AttrMenu.vue — без объяснения (пустой ключ, v-uiHelp не биндится)
        uiHelpKey() {
            if (this.attr?.uiHelp) return String(this.attr.uiHelp)   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): ключ из определения меню — Copy / Style таблицы (AttrGrid.set_commandPanel)
            const cls = String(this.attr?.cssClass || '')
            if (cls.includes('pi-arrow-right-arrow-left')) return 'widget.header.btn.compare'
            if (cls.includes('pi-verified')) return 'widget.header.btn.approve'
            return ''
        },
        headerHtml() { return typeof this.attr?.headerHtml === 'string' && this.attr.headerHtml ? this.attr.headerHtml : undefined },   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
        menuClass() {
            return [
                this.attr['cssClass'],
                'commandPanel-buttons-menu p-button-secondary p-button-sm mr-2 p-2', {
                'menu-labelled': !!this.headerHtml,   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
                // 'p-button-active': this.attr.active,
            }]
        },
        itemsSourceMenu() {
            void langVersion.value   // IE 2026 09 24 / ODOO-341407: пункты переподписаны на месте — новый массив заставляет wijmo перерисовать список
            const items = []
            for (let item of this.attr?.attrs || []) {
                if (item.use === false || item.hidden === true || !this.store.checkAccess(item, this.WIDGET)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                    continue
                }
                items.push(item)
            }
            return items
        },
    },
}
</script>

<style>
.widget_menu .wj-template {
    display: none;
}
.pi-bold {
    font-size: larger;
    font-weight: bolder;
}
.commandPanel-buttons-menu .wj-template {
    display: none;
}
.wj-listbox-item {
    z-index: 99999;
    box-shadow: none !important;
}
/* IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): меню с подписью (attr.headerHtml) — поле заголовка wijmo видно,
   кнопка как в прототипе (раздел 1): чипы видов плана + «Plan approval ▾»; шрифт интерфейса (не primeicons); наведение меняет только фон — ширина та же */
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-template { display: block; }
.widget_menu .commandPanel-buttons-menu.menu-labelled { display: inline-flex; align-items: center; width: auto; height: auto; min-height: 0; padding: 3px 9px !important;
    border: 1px solid #b9c4f0; border-radius: 7px; background: #fff; box-shadow: none; cursor: pointer; font-family: var(--ie-ui-font); }
.widget_menu .commandPanel-buttons-menu.menu-labelled:hover { background: #f3f4f8; }
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-input,
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-input-group,
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-form-control { display: inline-flex; align-items: center; width: auto; height: auto; min-height: 0; padding: 0; border: 0; background: transparent; box-shadow: none; }
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-input-group-btn { display: none; }
.pa-hdr { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; font-family: var(--ie-ui-font); font-size: 12.5px; font-weight: 600; line-height: 18px; color: #3346a8; }
.pa-hdr .pa-chip { font-size: 11px; font-weight: 600; line-height: 16px; padding: 0 7px; border-radius: 999px; background: #eef0f3; color: #3a3f47; white-space: nowrap; }
.pa-hdr .pa-chip.pa-tone-processed { background: #e8edff; color: #3346a8; }
.pa-hdr .pa-chip.pa-tone-approved { background: #e3f6e8; color: #1d7a3a; }
.pa-hdr .pa-chip.pa-tone-changed { background: #fff3d6; color: #8a5a00; }
.pa-hdr .pa-chip.pa-tone-withdrawn { background: #fde8e8; color: #a32020; }
.pa-hdr .pa-hdr-caret { font-size: 10px; }
.commandPanel-buttons-menu.menu-labelled.pa-tone-processed { border-color: #b9c4f0; }
.commandPanel-buttons-menu.menu-labelled.pa-tone-approved { border-color: #a9dcb8; }
.commandPanel-buttons-menu.menu-labelled.pa-tone-changed { border-color: #f0d08a; }
.commandPanel-buttons-menu.menu-labelled.pa-tone-withdrawn { border-color: #f2b8b8; }
/* IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): список меню из формы ячейки — над формой (.dropdown, z-index 9999); wijmo кладёт его в body со своим z-index 1500 (inline) — отсюда !important.
   html body …×2 — выше мобильного правила body.mobile-ui .wj-dropdown-panel:has(.wj-menu-item-row) { z-index: 1500 !important } (0,3,1) */
html body .wj-dropdown-panel.menu-over-form.menu-over-form { z-index: 10060 !important; }
</style>